import { Context } from '@nuxt/types'

// .App\\Events\\User\\ClaimedInvite
export default (ctx: Context) => {
  return (message: any) => {
    ctx.$logger.info('refresh auth handler', message)
    ctx.store.dispatch('auth/refresh')
  }
}
